module.exports = __webpack_public_path__ + "img/logo-dark.3e57fce7.png";